/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

import { IInteractiveFeatureCollectionViewProps } from './interactive-feature-collection';

/**
 * Feature Collection View.
 * @param props - Feature Collection view props.
 * @returns Feature Collection View.
 */
export const interactiveFeatureCollectionView: React.FC<IInteractiveFeatureCollectionViewProps> = props => {
    const {
        title,
        interactiveFeatureCollectionHeading,
        interactiveFeatureCollectionContainer,
        interactiveFeatureCollectionDesktopContainer,
        interactiveFeatureCollectionDesktopItems,
        interactiveFeatureCollectionMobileItems,
        interactiveFeatureCollectionMobileContainer,
        singleSlideCarouselComponentProps,
        singleSlideCarouselItemContainer
    } = props;
    return (
        <Module {...interactiveFeatureCollectionContainer}>
            <Node {...interactiveFeatureCollectionHeading}>{title}</Node>
            <Node {...interactiveFeatureCollectionDesktopContainer}>{interactiveFeatureCollectionDesktopItems}</Node>
            <Node {...interactiveFeatureCollectionMobileContainer}>
                <Node {...singleSlideCarouselComponentProps}>
                    {interactiveFeatureCollectionMobileItems.map((tileItem: ReactNode, index: number) => {
                        const keyIndex = `interactive-feature-carousel-item__${index}`;
                        return (
                            <Node {...singleSlideCarouselItemContainer} key={keyIndex}>
                                {tileItem}
                            </Node>
                        );
                    })}
                </Node>
            </Node>
        </Module>
    );
};

export default interactiveFeatureCollectionView;
